<!--
-->

<script>
import { SysVars } from '../main';
import { formatValue } from '../shared/utils'

export default {
    props: ['params'],

    data () {
        return {
            searchString: '',
            inicio: true,
            noItems: true,
            showItems: false,
            errorMessage: '',
            error: false,
            localItemList: [],
            originalTop: 0,
            scrollY: 0,
            myStyle: {},
        }
    },
    computed: {

        itemList: function () {
            return this.$store.getters.getItemSalesList
        },

        metadata: function () {
            return this.$store.getters.getEntities.metadata
        },

        myDropDown: function () {
            // console.log(this.$refs.pesquisa.getBoundingClientRect())
            const rect = this.$refs.pesquisa.getBoundingClientRect();
            // return 'top: ' + rect.top + 'px; left: ' + rect.left + 'px;'
            //return 'top: 764.297px; left: 235px;'
        }

    },

    filters: {
        format: function (value) {
            return formatValue(value, 4)
        },
    },

    methods: {
        scrollTop () {
        },

        addItens () {
            var selectedItems = []
            this.error = false
            for (var x = 0; x < this.localItemList.length; x++){
                if (this.localItemList[x].vlr && this.localItemList[x].vlr != 0) {
                    let item = {...this.localItemList[x]}
                    selectedItems.push(item)
                }
            }
            if (!this.error) {
                this.handleEsc()
                this.$emit('additem', selectedItems)
            }
        },

        handleEsc() {
            this.showItems = false
            this.searchString = ''
            this.$refs.pesquisa.focus()
        },

        handleEnter(index) {
            if (index + 1 == this.itemList.length) {
                this.addItens()
            }
        },

        focus () {
            this.$refs.pesquisa.focus()
        },

        closeForm () {
            this.$emit('closeform')
        },

        handleChange() {
            // console.log(this.searchString)
            if (!this.searchString) {
                this.showItems = false
                return
            }
        },

        search () {
            //efetua a pesquisa por descricao ou por codigo
            this.inicio = false

            if (!this.searchString) {
                this.showItems = false
                return
            }

            this.searchString = this.searchString.toUpperCase()
            this.filter = '{"descricao":{"$or":[{"$like":"%25' + this.searchString + '%25"},{"codigo":{"$eq":"' + this.searchString + '"}}]}}'
            this.loadData()
        },

        loadData () {
            this.$store.dispatch('loadItemSales', { filter: this.filter })
        },

        existe (coditem) {
            //CHECA SE O ITEM JÁ FOI LANCADO NO PEDIDO
            if (this.params && this.params.pedvit) {
              let obj = this.params.itens.find(o => o.coditem === coditem)
              if (obj) {
                  return true
              } else {
                  return false
              }
            } else
              return false
        },
    },

    watch: {

        itemList: function () {
            if (this.inicio) {
                return
            }
            if (!this.itemList.length) {
                this.noItems = true
                this.showItems = false
            } else {
                this.noItems = false
                this.showItems = true
                //JOGA O FOCO PARA O PRIMEIRO ITEM DA PESQUISA
                this.$nextTick(function () {
                    this.$refs.preco[0].focus()
                })
            }
            this.localItemList = [...this.itemList]
            let vm = this
            jQuery.map(this.localItemList, function(value) {
                value.vlr = null
                value.vlrmin = null
                return value
            })
        },

        scrollY: function () {
            //EFETUA O CONTROLE DA BARRA DE PESQUISA EM RELAÇÃO AO SCROLL DA TELA
            const rect = this.$el.getBoundingClientRect();
            const newTop = this.scrollY; // - this.originalTop;
            if (rect.top < -50) {
                this.$set(this.myStyle, 'top', 0);
                this.$set(this.myStyle, 'position', 'fixed');
                // this.$set(this.myStyle, 'width', '80%');
            } else {
                this.$delete(this.myStyle, 'top');
                this.$delete(this.myStyle, 'position');
                // this.$set(this.myStyle, 'min-width', '100%');
            }

        }
    },

    components: {
    },

    created () {
        this.$store.dispatch('clearItemSales')

        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip()
        })
    },

    mounted () {
        this.$refs.pesquisa.focus()

        // console.log(this.$el)

        this.originalTop = this.$el.getBoundingClientRect().top;

        window.addEventListener('scroll', (event) => {
            this.scrollY = Math.round(window.scrollY);
            // console.log(this.scrollY)
        });

    }

}

</script>

<template>

 	<div class="nb-margin-bottom w-100">
        <div class="headerpesquisa" style="position: relative; width: 100%; z-index: 10; background-color: white">
            <!-- <label-title icon="fa-search" title="Pesquisar Produtos"></label-title> -->
            <div class="row">
                <div class="col-md-6 col-12">
                    <div class="input-group">
                        <input ref="pesquisa" class="form-control form-control-sm" id="search" type="text" placeholder="Pesquisa pela descrição ou pelo código do item" v-model="searchString" @change="handleChange()" @keyup.esc="handleEsc()" @keyup.enter="search()">
                        <span class="input-group-btn">
                            <button class="btn btn-sm btn-outline-secondary" tabindex="1" style="margin-right: 5px" type="submit" @click="search()">
                                    <i class="fa fa-search" aria-hidden="true"></i>
                            </button>
                        </span>
                        <div class="btn-group">
                            <a href="javascript:void(0);" class="btn btn-sm btn-outline-secondary" title="Mais Filtros" v-if="false" @click="search()">...</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="showItems" class="dropdown-select-item" :style="myDropDown" @keyup.esc="handleEsc()">
            <div style="position: absolute; margin-left: 70%; z-index: 10; background-color: transparent" :style="myStyle">
                        <!-- <v-button :tabindex="1" label="Cancelar" @click="handleEsc()"></v-button> -->
                        <v-button :tabindex="1" :nb-btdef="true" label="Adicionar" icon="fa-plus" @click="addItens()"></v-button>
            </div>
            <div style="margin-top: 50px">
                <div v-for="(item,index) in localItemList" v-bind:key="index">
                    <div class="row align-items-center">
                        <div class="col-md-6 col-10">
                            <span class="lbl-title-produto">{{ item.descricao }}</span>
                            <span v-if="existe(item.coditem)" class="badge badge-yellow-outline">Adicionado</span>
                            <span class="data-list w-100">{{ item.codigo }}</span>
                        </div>
                        <form-field ref="preco" v-model="item.vlr" :precision="2" type="value" col="2" label="Preço"></form-field>
                        <form-field v-model="item.vlrmin" :precision="2" type="value" col="2" label="Preço Mínimo" @keyenter="handleEnter(index)"></form-field>
                    </div>
                    <hr>
                </div>
            </div>
        </div>

    </div>

</template>





<style>

.dropdown-select-item {
    position: absolute;
    width: 100%;
    z-index: 1051;
    margin-top: 3px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
    position: absolute;
    padding: 10px;
    z-index: 1000;
    float: left;
    min-width: 160px;
    list-style: none;
    background-color: #fff;
    border: 1px solid rgba(0,0,0,0.2);
    box-shadow: 0 5px 10px rgba(0,0,0,0.2);
    background-clip: padding-box;
}
</style>



// WEBPACK FOOTER //
// src/forms/tabpre-add-form.vue